import { render, staticRenderFns } from "./OtherLabourView.vue?vue&type=template&id=014cfe6a"
import script from "./OtherLabourView.vue?vue&type=script&lang=js"
export * from "./OtherLabourView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('014cfe6a')) {
      api.createRecord('014cfe6a', component.options)
    } else {
      api.reload('014cfe6a', component.options)
    }
    module.hot.accept("./OtherLabourView.vue?vue&type=template&id=014cfe6a", function () {
      api.rerender('014cfe6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/otherlabour/OtherLabourView.vue"
export default component.exports